/**
 * Individual wheel aspect label
 */
import React, { Component, PropTypes } from 'react';
import CircleType from 'circletype';

class WheelLabel extends Component {
  constructor(props) {
    super(props);
    this.circleText = this.circleText.bind(this);
    this.ref = (element) => {
      this.el = element;
      this.circleText();
    };
  }

  circleText() {
    const element = this.el;
    if (element) {
      const span = element.querySelector('span > span');
      /* eslint-disable no-new */
      const { shortName } = this.props.aspect;
      const radius = document.querySelector('.wheel-wrapper').offsetWidth / 2;
      if (shortName === 'Purpose' || shortName === 'Security') {
        this.circle = new CircleType(span).radius(radius).dir(-1);
      } else {
        this.circle = new CircleType(span).radius(radius);
      }
    }
    element.querySelector('span').classList.add('is-loaded');
  }

  render() {
    const {
      aspect,
      className,
      entityId,
      hoveredAspect,
      setHoveredAspect,
    } = this.props;
    const onMouseEnter = () => setHoveredAspect(entityId);
    const onMouseLeave = () => setHoveredAspect(null);
    return (
      <li
        className={`${className} ${aspect.shortName.toLowerCase()} ${(hoveredAspect === entityId) && 'is-hovered'}`}
        key={`wheel-label-${entityId}`}
        ref={this.ref}
      >
        <span
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <span>{aspect.shortName.toUpperCase()}</span>
        </span>
      </li>
    );
  }
}

WheelLabel.propTypes = {
  aspect: PropTypes.shape({}),
  className: PropTypes.string,
  entityId: PropTypes.string,
  setAspect: PropTypes.func,
  setHoveredAspect: PropTypes.func,
};

export default WheelLabel;



// WEBPACK FOOTER //
// js/src/wheel/WheelLabel.js